/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FormattedMessage } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";

/* Helpers, constants, custom methods, internal libraries */
import { PEOPLE_ROUTE } from "../../constants/routes";
import { AIRLINES } from "../../constants/appConstants";
import { useUserContext } from "../../contexts/userContext";

/* Components */
import { ReactComponent as CardIcon } from "../../resources/images/credit-card-badge.svg";
import Breadcrumbs from "../breadcrumbs";

/* Styles */
import styles from "./styles.js";

const TravelerDetailsHeader = ({ travelerDetails }) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  return (
    <div className={classes.peoplePageHeader}>
      <Breadcrumbs
        items={[
          <Link to={PEOPLE_ROUTE}>
            <FormattedMessage id="breadcrumbs.people"/>
          </Link>,
          <>
            {Object.keys(travelerDetails).length === 0 ? (
              <Skeleton
                count={1}
                width={205}
                className={classes.skeletonName}
              />
            ) : (
              travelerDetails.firstName + " " + travelerDetails.lastName
            )}
          </>
        ]}
      />
      <Container className={classes.container}>
        <Row>
          <Col xs={12} className='gx-0'>
            <div className={classes.titleBadgeWrapper}>
              <h1 className={classes.title}>
                {Object.keys(travelerDetails).length === 0 ? (
                  <Skeleton
                    count={1}
                    width={305}
                    className={classes.skeletonName}
                  />
                  ) : (
                  travelerDetails?.firstName + " " + travelerDetails?.lastName
                )}
              </h1>
              {travelerDetails?.authorizedUser && providerCode === AIRLINES.AA && (
                <div className={classes.badgeWrapper}>
                  <CardIcon />
                  <p>
                    <FormattedMessage id='traveler.authorizedCardBadge' />
                  </p>
                </div>
              )}
              {travelerDetails?.companyInfo?.companyType === "Citi" && travelerDetails?.primaryContact && providerCode === AIRLINES.AA && (
                <div className={classes.badgeWrapper}>
                  <CardIcon />
                  <p>
                    <FormattedMessage id="traveler.primaryCardmember" />
                  </p>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TravelerDetailsHeader;
